import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY');
}

// Warnung, wenn möglicherweise der falsche Schlüssel verwendet wird
// Anon keys sind JWT Tokens die normalerweise mit "eyJ" beginnen
// Service role keys sind deutlich länger (oft > 500 Zeichen) und enthalten "service_role" im Payload
const isLikelyServiceRoleKey = supabaseAnonKey.includes('service_role') || 
                                (supabaseAnonKey.length > 500 && !supabaseAnonKey.startsWith('eyJ'));

if (isLikelyServiceRoleKey) {
  console.error(
    '⚠️ WARNUNG: Es sieht so aus, als würden Sie den service_role Key verwenden!\n' +
    'Der service_role Key ist GEHEIM und darf NUR auf dem Server verwendet werden.\n' +
    'Für Browser-Anwendungen müssen Sie den "anon" oder "public" Key verwenden.\n' +
    'Gehen Sie zu: Supabase Dashboard → Settings → API → anon/public key'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

